<template>
  <div class="stepContainer step3">
    <step-header :title="courseInfo.siteCourseName"/>
    <div class="m-content">
      <div class="title clearfix">
        <span class="h_left">考生须知</span>
      </div>
      <div class="m-html">
        <iframe scrolling="auto" frameborder="0" marginwidth="10" marginheight="0"
                src="//www.chinaacc.com/tiku_old/jkxt/xu20201029145243.shtml" height="800px" width="100%"/>
      </div>
      <div class="timer">
        离考试开始还有00:00:{{count}}
      </div>
    </div>
  </div>
</template>
<script>
  import { StepHeader } from "@components/common"
  import { mapGetters } from 'vuex'
  import { setPageTitle, isEmptyObject, parseNumber, getCookie } from "@/utils"
  import { checkTempPaper } from '@api'

  export default {
    name: 'Step3',
    components: {
      StepHeader
    },
    computed: {
      ...mapGetters([
        'siteData'
      ]),
    },
    data() {
      return {
        courseInfo: {},
        siteCourseID: '',
        courseID: '',
        intro: '',
        isClick: false,
        flag: '',
        count: 10,
        timer: null
      }
    },
    async mounted() {
      const { flag } = this.$route.params
      let _flag = flag === 'paidExam' ? '' : flag
      const { siteCourseID, courseID } = this.$route.query
      const { majorID } = this.$categoryInfo
      this.siteCourseID = parseNumber(siteCourseID)
      this.courseID = courseID

      if (isEmptyObject(this.siteData)) {
        let params = {
          flag: _flag,
          majorID: majorID,
          siteCourseID: this.siteCourseID
        }
        await this.$store.dispatch('getCurrentSiteInfo', params)
        .then(res => {
          this.courseInfo = res.currentCourse
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
      } else {
        this.courseInfo = this.siteData.currentCourse
      }
      this.intro = this.courseInfo.examNeedUrl
      document.title = setPageTitle(this.courseInfo&&this.courseInfo.siteCourseName)
      this.countDown()
    },
    methods: {
      countDown() {
        let numToStr = number => (number > 9 ? number.toString() : '0' + number)
        this.timer = setInterval(() => {
          if (parseInt(this.count) <= 0){
            clearInterval(this.timer)
            this.timer = null
            this.examStart()
          } else {
            this.count = numToStr(parseInt(this.count) - 1)
          }
        }, 1000)
      },
      examStart() {
        const { flag } = this.$route.query
        if (flag === 'ordinary') {
          return this.$router.push({
            path: '/ordinaryExam',
            query: { ...this.$route.query }
          })
        }
        let uid = getCookie('cdeluid') || ''
        let params = {
          siteCourseID: this.siteCourseID,
          flag: this.flag,
          userID: parseNumber(uid)
        }
        // 查询是否有临时保存试题
        checkTempPaper(params).then(res => {
          const { flag } = this.$route.params
          if (res.length > 0) {
            const tempData = res[0]
            let _confirm = confirm('请确认 ：是否继续上次未完成的试卷?\n按“确定”将打开上次的试卷\n按“取消”则打开新试卷')
            if (_confirm) {
              return this.$router.replace({
                path: `/${flag}/doExam`,
                query: {
                  siteCourseID: this.siteCourseID,
                  courseID: this.courseID,
                  bizID: String(tempData.bizID),
                  spendTime: String(tempData.spendTime),
                  temp: '2'
                }
              })
            } else {
              return this.$router.replace({
                path: `/${flag}/doExam`,
                query: {
                  siteCourseID: this.siteCourseID,
                  courseID: this.courseID,
                  // bizID: String(tempData.bizID),
                  spendTime: 0,
                  temp: '1',
                  includeTempButAbandon: '1'
                }
              })
            }
          }
          return this.$router.replace({
            path: `/${flag}/doExam`,
            query: {
              siteCourseID: this.siteCourseID,
              courseID: this.courseID,
              temp: '1'
            }
          })
        })
      }
    },
    beforeDestroy() {
      if(this.timer){
        clearInterval(this.timer)
      }
    }
  }
</script>
